import { styled } from "@mui/system";
import { Autocomplete, TextField } from "@mui/material";

const baseTextFieldStyles = {
  width: "100%",
  "& .MuiInputBase-root": {
    borderRadius: "16px",
    padding: "0px 10px",
  },
  "& .MuiInputBase-input": {
    height: "24px",
    padding: "12.5px 14px",
    lineHeight: "16px",
    color: "#002035",
    fontFamily: "Söhne",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
  },
  "& .MuiOutlinedInput-root": {
    height: "49px",
  },
};

const handleChange = ({
  selected,
  custombgcolour,
  error,
  disabled,
}: {
  selected: boolean;
  custombgcolour?: string;
  error?: boolean;
  disabled?: boolean;
}) => {
  type Styles = {
    [key: string]: string | Styles;
  };

  let additionalStyles: Styles = {};

  // Do not show success (green) styling when the field is in an error state — MUI still sets
  // `error` on the outline, which was stacking with the green border from `selected`.
  if (selected && !error) {
    additionalStyles = {
      "& .MuiOutlinedInput-root": {
        paddingRight: "20px !important",
        "@media (max-width: 767px)": {
          paddingRight: "10px !important",
        },
      },
      "& .MuiInputBase-root": {
        height: "49px",
        padding: "0px 10px",
        borderRadius: "16px",
        background: custombgcolour ? custombgcolour : "",
        border: "1px solid #0BEC9F",
        "& fieldset": {
          borderColor: "transparent",
        },
      },
      "& .MuiOutlinedInput-notchedOutline": { border: "#0BEC9F" },
      "& .MuiFormLabel-root": {
        background: "white",
        padding: "0px 10px",
      },
    };
  }

  if (error) {
    additionalStyles["borderRadius"] = "var(--spacing, 16px)";
    additionalStyles["& .MuiOutlinedInput-notchedOutline"] = {
      border: "1px solid var(--primary-salmon-500-p, #FC4C4C)",
    };
  }

  return { ...baseTextFieldStyles, ...additionalStyles };
};

export const StyledTextField = styled(TextField)(handleChange);
export const SearchAddress = styled(TextField)(handleChange);
export const AutoCompleteStyled = styled(Autocomplete)(handleChange);
export const StyledErrorField = styled("span")({
  color: "#cc0000",
  fontSize: "12px",
});

// Provide default SelectProps so all selects using StyledTextField get consistent menus
StyledTextField.defaultProps = {
  SelectProps: {
    MenuProps: {
      PaperProps: {
        sx: {
          borderRadius: "0px 0px 8px 8px",
          overflow: "hidden",
          boxShadow: "0px 12px 24px rgba(216, 216, 218, 0.80)",
        },
      },
    },
  },
};
